export interface StreakTier {
  threshold: number;
  multiplier?: number;
}

export interface StreakConfig {
  tiers: StreakTier[];
}

export const HARMONY_CONFIG: StreakConfig = {
  tiers: [
    { threshold: 15, multiplier: 1.5 },
    { threshold: 25, multiplier: 2 },
    { threshold: 35, multiplier: 3 },
  ],
};

export const PATIENCE_CONFIG: StreakConfig = {
  tiers: [
    { threshold: 12 },
    { threshold: 20 },
    { threshold: 28 },
  ],
};

export const RHYTHM_CONFIG: StreakConfig = {
  tiers: [
    { threshold: 2 },
    { threshold: 3 },
    { threshold: 4 },
  ],
};

export function getCurrentTier(count: number, config: StreakConfig): number {
  let tier = 0;
  for (const t of config.tiers) {
    if (count >= t.threshold) tier++;
    else break;
  }
  return tier;
}

export function getHarmonyMultiplier(count: number): number {
  const tier = getCurrentTier(count, HARMONY_CONFIG);
  if (tier === 0) return 1;
  return HARMONY_CONFIG.tiers[tier - 1].multiplier!;
}
